import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";

import { steps } from "constants/domains";

type dataType = {
 domain: string;
 authinfo: string;
 provider: string;
 year: number;
 registrant: number;
 admin: number;
 billing: number;
 technical: number;
 web: number;
 mail: number;
 ns: number;
 amount: number;
};

const StepRendering = ({
 stepValue,
 availability,
 data
}: {
 stepValue: number;
 availability: string;
 data: dataType;
}): ReactElement => {
 const checkStepCompletes = (index: number): boolean => {
  switch (index) {
   case 0:
    return data.domain !== "";
   case 1:
    return (availability === "TRANSFER" && data.authinfo !== "") || availability !== "TRANSFER";
   case 2:
    return data.year > 0;
   case 3:
    return data.provider !== "";
   case 4:
    return data.registrant !== 0 && data.admin !== 0 && data.billing !== 0 && data.technical !== 0;
   case 5:
    return data.mail !== 0 && data.web !== 0 && data.ns !== 0;
   default:
    return false;
  }
 };

 const renderOptionalMessage = (index: number) => {
  if (index === 1) {
   if (availability === "TRANSFER") {
    return (
     <Typography variant="caption">
      <FormattedMessage id="domain.authinfoNeeded" />
     </Typography>
    );
   } else {
    return (
     <Typography variant="caption">
      <FormattedMessage id="domain.authinfoNotNeeded" />
     </Typography>
    );
   }
  } else {
   return <></>;
  }
 };

 return (
  <Stepper activeStep={stepValue} orientation="vertical">
   {steps.map((step, index) => (
    <Step key={step.title} completed={checkStepCompletes(index)}>
     <StepLabel optional={renderOptionalMessage(index)}>
      <FormattedMessage id={step.title} />
     </StepLabel>
    </Step>
   ))}
  </Stepper>
 );
};

export default StepRendering;
